import { render, staticRenderFns } from "./order-stock-input.vue?vue&type=template&id=5f8b6ce8&"
import script from "./order-stock-input.vue?vue&type=script&lang=js&"
export * from "./order-stock-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports